import e from "react";
import { Text as a } from "../../../Text/Text.js";
const o = _ref => {
  let {
    children: t
  } = _ref;
  return t ? e.createElement(a.Caption, {
    tag: "p",
    className: "olx-ad-card__status"
  }, "online") : null;
};
export { o as OnlineStatus };